var _path, _g, _path2, _path3, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_834_556)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_834_556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_834_556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2773 0.703125V2.57812",
    stroke: "white",
    strokeWidth: 1.59948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8398 0.703125V2.57812",
    stroke: "white",
    strokeWidth: 1.59948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3525 14.2455L16.5589 19.4531L18.7653 14.2455",
    stroke: "white",
    strokeWidth: 1.59948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_834_556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_834_556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8405 1.64063H20.9521C22.5093 1.64063 23.6335 3.13102 23.2057 4.62825L21.3395 11.1599C20.7297 13.2942 18.779 14.7656 16.5593 14.7656C14.3396 14.7656 12.3889 13.2942 11.7791 11.1599L9.91289 4.62825C9.48511 3.13102 10.6094 1.64063 12.1665 1.64063H13.278",
    stroke: "white",
    strokeWidth: 1.59948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51562 17.5781V15.2813C3.51562 13.4432 5.00569 11.9531 6.84375 11.9531C8.68181 11.9531 10.1719 13.4432 10.1719 15.2813V20.1034C10.1719 21.8671 11.6017 23.2969 13.3654 23.2969C15.1291 23.2969 16.5589 21.8671 16.5589 20.1034V19.4531",
    stroke: "white",
    strokeWidth: 1.59948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.703125 20.3906C0.703125 21.9439 1.96233 23.2031 3.51562 23.2031C5.06892 23.2031 6.32812 21.9439 6.32812 20.3906C6.32812 18.8373 5.06892 17.5781 3.51562 17.5781C1.96233 17.5781 0.703125 18.8373 0.703125 20.3906Z",
    stroke: "white",
    strokeWidth: 1.59948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 20.3906C2.8125 20.7789 3.12731 21.0938 3.51562 21.0938C3.90394 21.0938 4.21875 20.7789 4.21875 20.3906C4.21875 20.0023 3.90394 19.6875 3.51562 19.6875C3.12731 19.6875 2.8125 20.0023 2.8125 20.3906Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_834_556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/Doctor.d7bd8916ba71911cf87185dca9938b9f.svg";
export { ForwardRef as ReactComponent };